/**
 * Export file names, from the original `features/export/saveImage.ts` (`exportFileName`) with
 * the clock injected. Uses LOCAL time components of `date`.
 * Format: `better-lights-<kind>[-<suffix>]-<YYYYMMDD>-<HHMMSS>.jpg`.
 */
export function exportFileName(kind: 'demo' | 'lines' | 'ai', suffix?: string, date: Date = new Date()): string {
  const d = date;
  const pad = (n: number) => String(n).padStart(2, '0');
  const stamp = `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}-${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
  const tag = suffix ? `-${suffix.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')}` : '';
  return `better-lights-${kind}${tag}-${stamp}.jpg`;
}
